import type { ComponentType } from "react";

import type { ApplyDetailType } from "../../../api";

export type AppliesIntegrationSectionProps = {
  apply: ApplyDetailType;
};

export type AppliesIntegrationSection = ComponentType<AppliesIntegrationSectionProps>;

/**
 * Per-integration detail sections for the applies module, keyed by integration name — the same names
 * `ApplyDetailType.appliesModules` reports. Keeps ApplyDetailPage integration-agnostic: an integration's
 * identifiers, warnings and actions register themselves here instead of the page knowing which
 * integrations exist.
 */
const integrationSectionsRegistry = new Map<string, AppliesIntegrationSection>();

export function registerAppliesIntegrationSection(
  integrationName: string,
  section: AppliesIntegrationSection,
): void {
  integrationSectionsRegistry.set(integrationName.toLowerCase(), section);
}

export function getAppliesIntegrationSection(
  integrationName: string | undefined,
): AppliesIntegrationSection | undefined {
  if (!integrationName) return undefined;

  return integrationSectionsRegistry.get(integrationName.toLowerCase());
}
